import BasketballStats from "./BasketballStats";

export default BasketballStats;
